const localStorage = window.localStorage;

export const storage = {
    setItem: function(key, item) {
        if (!key) {
            return;
        }

        if (item === undefined || item === null) {
            return;
        }

        if (typeof item === 'string' && !item) {
            return;
        }

        let itemToStore = typeof item === 'string' ? item : JSON.stringify(item);
        localStorage.setItem(key, itemToStore);
    },
    getItem: function(key) {
        if (!key) {
            return;
        }

        return JSON.parse(localStorage.getItem(key));
    },
    removeItem: function(key) {
        localStorage.removeItem(key);
    },
    clear: function() {
        localStorage.clear();
    },
    getAllKeys: function() {
        return new Promise((resolve)=>{
            resolve(Object.entries(localStorage));
        });
    },
    getMultipleItems: function(keys) {
        if (!Array.isArray(keys) || keys.length === 0) {
            return [];
        }

        return keys.map(key => [key, this.getItem(key)]);
    }
};
